import React from "react";
import { Accordion } from "../Form";
import { MESSAGE_CATEGORY_PREFIX, MESSAGE_DRAFT_MESSAGE, MESSAGES } from "../../classConstants";
import { Message } from "./Message";
import { getClassName } from "../../helpers";
import get from "lodash/get";
export var Messages = function (props) {
    var messages = props.messages.map(function (item, index) {
        var _a;
        var _b, _c;
        return React.createElement(Message, { title: item.get("subject"), item: item, index: index, key: item.id, defaultCollapsed: props.defaultCollapsed, className: getClassName(MESSAGE_CATEGORY_PREFIX + "-" + ((_c = (_b = item.category) === null || _b === void 0 ? void 0 : _b.replaceAll("_", "-")) !== null && _c !== void 0 ? _c : "unknown"), (_a = {},
                _a[MESSAGE_DRAFT_MESSAGE] = item.isDraft,
                _a)) });
    });
    var getPageTitle = function () {
        var title = props.title;
        return title ? React.createElement("h3", null,
            title,
            " ") : null;
    };
    return (React.createElement(Accordion, { className: getClassName(MESSAGES, get(props, "className")), connectedAccordion: false },
        getPageTitle(),
        props.children,
        messages));
};
